/**
 * @fileoverview Service de autenticação.
 *
 * Gerencia login/logout do sistema, incluindo:
 * - Login via credenciais (username/password)
 * - Login via SSO SignGO (OpenID Connect)
 * - Logout com limpeza de localStorage
 *
 * Utiliza OAuth 2.0 via Doorkeeper no backend.
 *
 * @module services/AuthenticationService
 */

import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';

/**
 * Service de autenticação.
 * @namespace AuthenticationService
 */
const AuthenticationService = {
  /**
   * Realiza login via credenciais.
   * Retorna token OAuth 2.0 (access_token).
   *
   * @param {string} username - Nome de usuário (login)
   * @param {string} password - Senha do usuário
   * @returns {Promise<import('axios').AxiosResponse<{access_token: string, token_type: string, expires_in: number}>>}
   */
  signin(username, password) {
    return axios.post('oauth/token', { username, password, grant_type: 'password' });
  },

  /**
   * Realiza login via SSO SignGO.
   * Usado após autenticação externa no SignGO.
   *
   * @param {Object} payload - Dados do usuário do SignGO
   * @param {string} payload.uid - UID do usuário no SignGO
   * @param {string} payload.email - Email do usuário
   * @param {string} token - Token OAuth do SignGO
   * @returns {Promise<import('axios').AxiosResponse>}
   */
  signin_with_signgo(payload, token) {
    const user = payload;
    user.token = token;
    return axios.post(`${API_V2_URL()}/oauth/sign_go/authorize`, user);
  },

  /**
   * Realiza logout limpando dados locais.
   * Remove token, dados do usuário e preferências de sessão.
   */
  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem('selectedAdministrativeUnit');
    localStorage.removeItem('last_login_time');
  },
};

export default AuthenticationService;



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js